import { connect } from "react-redux";
import { RootState } from "store/store";
import NewGuestTenant from "./NewGuestTenant";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import { setModalLoaderVisibility } from "store/common/modal-window/modal-window-slices";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
    };
};

const NewGuestTenantContainer = connect(mapStateToProps, {
    setModalLoaderVisibility,
})(NewGuestTenant);

export default NewGuestTenantContainer;
